<script setup lang="ts">
import { useMediaQuery } from "@vueuse/core";
import type { MintTaskListItem } from "@umi/api/schemas/task";
import { Buffer } from "buffer";


// v3 exported this from @umi/shared/const; v4 const no longer has it.
const NATIVE_TOKEN_PRICES_TIMEOUT = 10_000;

const authStore = useAuthStore();

if (import.meta.client) {

  window.Buffer = Buffer;
  const config = useRuntimeConfig();
  const colorMode  = useColorMode();
  const chainStore = useChainStore();
  const isAuthenticated = computed(() => authStore.isAuthenticated);
  const isCursed = computed(() => authStore.isUser.cursed);
  (globalThis as any).umi = {
    stage: config.public.stage,
    apiUrl: config.public.apiUrl,
    jwt: LocalStorage.jwt.value,
  };
  colorMode.value = isCursed.value ? "light" : colorMode.value; // Force light mode for cursed users

  const isMobile = useMediaQuery('(max-width: 639px)')
  provide("isMobile", isMobile);

  let pricesInFlight = false;

  // Fetch native token prices from the API.
  // @note Only fetches if the user is authenticated.
  const fetchNativeTokenPrices = async () => {
    if (!isAuthenticated.value || pricesInFlight) return;
    pricesInFlight = true;
    try {
      const prices = await useORPC().feed.getPrices();
      // Merge so a partial fetch does not drop the prices we already know.
      chainStore.usdPrices = { ...chainStore.usdPrices, ...prices };
    } catch (error) {
      console.error("Failed to fetch native token prices", error);
    } finally {
      pricesInFlight = false;
    }
  };

  fetchNativeTokenPrices();
  setInterval(() => fetchNativeTokenPrices(), NATIVE_TOKEN_PRICES_TIMEOUT);

  if (authStore.isAuthenticated) connectWebsocket();
  eventBus.on("ws:event", (event) => {
    if (event.type !== "tasks:update" || !Array.isArray(event.tasks)) return;
    useTaskStore().updateTasksLocally(event.tasks as MintTaskListItem[]);
  });
}

</script>
<template>
  <ClientOnly>

    <div
      class="bg-white sm:bg-gray-50 dark:bg-gray-950 min-h-screen"
      :class="[
        authStore.user?.flags.isCursed ? 'grayscale' : '',
      ]">

      <!-- To have a transition between the loading  -->
      <Transition name="fade" mode="out-in">

        <div
          v-if="authStore.loading"
          class="fixed top-0 left-0 w-screen h-screen flex justify-center items-center">
          <GenericLoader class="animate-fade-in-up [animation-delay:500ms] opacity-0" />
        </div>

        <div v-else>
          <NuxtLayout>
            <NuxtPage />
          </NuxtLayout>
        </div>

      </Transition>

    </div>

    <UNotifications />

  </ClientOnly>
</template>
